module.exports = __webpack_public_path__ + "img/6.b2535982.png";